import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { Check, ShieldCheck, Gift, Users } from 'lucide-react';
import { useCurrency } from '../hooks/useCurrency';
import { trackAddToCart } from '../utils/metaPixel';
export function Hero() {
  const {
    currency
  } = useCurrency();
  const goToIntermedio = () => {
    const element = document.getElementById('cta-intermedio');
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  const scrollToPricing = () => {
    const element = document.getElementById('pricing-section');
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const scrollToContent = () => {
    const element = document.getElementById('recap-section');
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const includes = ['Rutina diaria de 10 min que sí vas a cumplir', 'Método probado para no abandonar el día 4', 'Plan de 21 días + bonos de regalo'];
  const lowestPrice = '$7.99 USD';
  return <section className="relative min-h-[100svh] flex items-center justify-center overflow-hidden" data-id="element-118">
      <div className="absolute inset-0 z-0" data-id="element-119">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a1628] via-[#0f1f38] to-[#0a1628] md:hidden" data-id="element-120" />
        <img src="https://cdn.magicpatterns.com/uploads/rt32L3eP563XmYaWetS7bd/heylloyd-image-1770158091043.png" alt="" className="hidden md:block w-full h-full object-cover" loading="eager" decoding="async" data-id="element-121" />
        <div className="hidden md:block absolute inset-0 bg-[#0a1628]/90 mix-blend-multiply" data-id="element-122" />
        <div className="hidden md:block absolute inset-0 bg-gradient-to-b from-[#0a1628]/70 via-[#0a1628]/40 to-[#0a1628]" data-id="element-123" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-5 text-center pt-16 pb-20 md:pt-20 md:pb-32" data-id="element-124">
        <FadeIn instant data-id="element-125">
          <div className="inline-flex items-center gap-2 py-1.5 px-4 bg-[#d4af37]/10 border border-[#d4af37]/30 rounded-full mb-6 md:mb-8" data-id="element-126">
            <Users className="w-3.5 h-3.5 text-[#d4af37]" data-id="element-127" />
            <span className="text-[#d4af37] text-xs md:text-sm font-medium" data-id="element-128">
              +500 personas ya empezaron su transformación
            </span>
          </div>
        </FadeIn>

        <FadeIn instant data-id="element-129">
          <h1 className="text-3xl md:text-6xl lg:text-7xl font-bold text-white mb-5 md:mb-6 leading-tight" data-id="element-130">
            Deja de empezar y abandonar.{' '}
            <span className="text-[#d4af37] italic block mt-2" data-id="element-131">
              Esta vez va a ser diferente.
            </span>
          </h1>
        </FadeIn>

        <FadeIn instant data-id="element-132">
          <p className="text-lg md:text-2xl text-gray-100 mb-8 md:mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-133">
            El sistema espiritual de 10 minutos diarios que convierte tu fe en
            disciplina real — sin culpa, sin perfeccionismo, sin volver a
            fallar.
          </p>
        </FadeIn>

        <FadeIn instant data-id="element-134">
          <div className="max-w-sm md:max-w-md mx-auto mb-8 md:mb-10" data-id="element-135">
            <ul className="space-y-2 md:space-y-3 text-left" data-id="element-136">
              {includes.map((item, i) => <li key={i} className="flex items-start text-gray-200" data-id="element-137">
                  <Check className="w-5 h-5 text-[#d4af37] mr-3 mt-0.5 flex-shrink-0" data-id="element-138" />
                  <span className="text-base md:text-lg" data-id="element-139">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn instant data-id="element-140">
          <div className="flex flex-col items-center" data-id="element-141">
            <Button onClick={goToIntermedio} className="w-full md:w-auto min-w-[320px] text-lg md:text-xl px-10 md:px-14 py-5 md:py-7 shadow-[0_0_30px_rgba(212,175,55,0.35),0_0_60px_rgba(212,175,55,0.15)] btn-shimmer font-semibold tracking-wide" data-id="element-142">
              Quiero ver los planes + los 3 bonos
            </Button>
          </div>
        </FadeIn>

        <FadeIn instant data-id="element-143">
          <div className="flex flex-col items-center gap-3 md:gap-4" data-id="element-144">
            <p className="text-gray-400 text-sm" data-id="element-145">
              Antes{' '}
              <span className="text-gray-500 line-through text-base" data-id="element-146">
                $29.99 USD
              </span>{' '}
              — Ahora{' '}
              <span className="text-white font-bold text-lg" data-id="element-147">$7.99 USD</span> —
              pago único
            </p>
            <button onClick={scrollToContent} className="text-gray-300 active:text-[#d4af37] md:hover:text-[#d4af37] transition-colors text-sm md:text-base underline underline-offset-4 decoration-gray-500 py-2" data-id="element-148">
              Ver todo lo que incluye
            </button>
          </div>
        </FadeIn>

        <FadeIn instant data-id="element-149">
          <div className="mt-6 md:mt-8 flex flex-col items-center gap-2 md:gap-3" data-id="element-150">
            <div className="flex items-center gap-2 text-gray-400 text-xs md:text-sm" data-id="element-151">
              <Gift className="w-4 h-4 text-[#d4af37]" data-id="element-152" />
              <span data-id="element-153">2 planes disponibles • 3 bonos incluidos gratis</span>
            </div>
            <div className="flex items-center gap-2 text-gray-500 text-xs" data-id="element-154">
              <ShieldCheck className="w-4 h-4 text-[#d4af37]/60" data-id="element-155" />
              <span data-id="element-156">Garantía de 7 días • Pago único y seguro</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}